<form class="gap-md grid" [formGroup]="form()">
  <app-expansion-panel [isOpen]="showErrors() && repartitionsAnnee.invalid" titre="Durée">
    <div class="ml-sm" ngProjectAs="chipLeft">
      <app-chip
        label="{{ duree.value ?? 0 | i18nPlural: anMapping }} : {{ getAllMonths() }} mois &middot; {{
          getAllWeeksCFA() | i18nPlural: semaineMapping
        }} CFA"
        variant="informative"
      />
    </div>
    <div class="p-md gap-md flex flex-col">
      <div>
        <label
          [class]="{
            'text-components-content-neutral-quaternary': form().disabled || !peutModifier(),
          }"
          hlmFieldLabel
          labelRequired
          >Durée de l'étape</label
        >
        <hlm-radio-group class="gap-md flex" formControlName="duree">
          <hlm-radio class="hidden" [value]="null"></hlm-radio>
          <hlm-radio id="annee-1" [value]="1"
            ><hlm-radio-indicator indicator />
            <label class="flex items-center" for="annee-1">1 an</label>
          </hlm-radio>
          <hlm-radio id="annee-2" [value]="2"
            ><hlm-radio-indicator indicator />
            <label class="flex items-center" for="annee-2">2 ans</label>
          </hlm-radio>
          <hlm-radio id="annee-3" [value]="3"
            ><hlm-radio-indicator indicator />
            <label class="flex items-center" for="annee-3">3 ans</label>
          </hlm-radio>
        </hlm-radio-group>
      </div>

      @if (duree.value) {
        <hlm-separator />

        <div class="gap-lg flex flex-col" formArrayName="repartitionsAnnee">
          @for (group of repartitionsAnnee.controls; track $index; let idx = $index) {
            <div class="gap-xxs flex flex-col">
              <span class="text-content-tertiary">Année 0{{ idx + 1 }}</span>
              <div class="gap-md flex" [formGroup]="group">
                <app-number-stepper-input
                  class="flex-1"
                  [min]="1"
                  [max]="12"
                  [invalid]="getRepartitionInvalid(idx, 'nombreMois')"
                  [disabled]="!peutModifier()"
                  label="Nombre de mois"
                  formControlName="nombreMois"
                  errorMessage="Doit être supérieur à 0"
                />
                <app-number-stepper-input
                  class="flex-1"
                  [min]="0"
                  [max]="53"
                  [invalid]="getRepartitionInvalid(idx, 'nombreSemaines')"
                  [disabled]="!peutModifier()"
                  label="Semaines CFA"
                  formControlName="nombreSemainesCFA"
                />
              </div>
            </div>
          }
        </div>
      }
    </div>
  </app-expansion-panel>

  <div class="gap-xs flex flex-col">
    <label
      [class]="{
        'text-components-content-neutral-quaternary': form().disabled || !peutModifier(),
      }"
      hlmFieldLabel
      labelRequired
      >Type de contrat</label
    >
    <label class="flex items-center" for="professionnalisation" hlmLabel>
      <hlm-checkbox
        id="professionnalisation"
        [checked]="isChecked('professionnalisation')"
        [disabled]="!peutModifier()"
        (checkedChange)="changed($event, 'professionnalisation')"
        value="professionnalisation"
      />
      <span class="ml-xs component-medium-medium">Contrat de professionnalisation</span>
    </label>
    <label class="flex items-center" for="apprentissage" hlmLabel>
      <hlm-checkbox
        id="apprentissage"
        [checked]="isChecked('apprentissage')"
        [disabled]="!peutModifier()"
        (checkedChange)="changed($event, 'apprentissage')"
        value="apprentissage"
      />
      <span class="ml-xs component-medium-medium">Contrat d'apprentissage</span>
    </label>
    <label class="flex items-center" for="autre" hlmLabel>
      <hlm-checkbox
        id="autre"
        [checked]="isChecked()"
        [disabled]="!peutModifier()"
        (checkedChange)="changed($event, 'autre')"
        value="autre"
      />
      <span class="ml-xs component-medium-medium">Autre</span>
      <input class="mx-sm" id="code-etape" hlmInput type="text" formControlName="autreType" />
    </label>
    @if (!typesContrat.value.length && !autreType.value && showErrors()) {
      <hlm-field-error>Vous devez sélectionner au moins un type de contrat.</hlm-field-error>
    }
    @if (typesContrat.value.includes('apprentissage') && !certification.value && showErrors()) {
      <hlm-field-error
        >Vous devez sélectionner une certification si vous choisissez un type de contrat
        d'apprentissage.</hlm-field-error
      >
    }
  </div>

  @if (cartographie()) {
    <div hlmField>
      <label
        [class]="{
          'text-components-content-neutral-quaternary': form().disabled || !peutModifier(),
        }"
        hlmFieldLabel
        for="select-modalites"
        >Modalité</label
      >
      @if (modalites().length > 0) {
        <hlm-select id="select-modalites" formControlName="modalite">
          <hlm-select-trigger class="capitalize">
            <hlm-select-value />
          </hlm-select-trigger>
          <hlm-select-content>
            @for (modalite of modalites(); track modalite.id) {
              <hlm-option class="capitalize" [value]="modalite.id">
                {{ modalite.nom }}
              </hlm-option>
            }
          </hlm-select-content>
        </hlm-select>
      } @else {
        <app-alerte
          message="Pour pouvoir sélectionner des modalités, il faut que les administrateurs en créent pour cette cartographie."
        />
      }
    </div>
  }
  <div hlmSeparator></div>

  <div class="gap-xs grid">
    <label class="component-medium-medium flex items-center" hlmLabel>
      <hlm-switch formControlName="estCertifiante" /> L'étape est certifiante
    </label>
  </div>

  @if (!estCertifiante.value) {
    <div class="gap-xxs grid">
      <label
        [class]="{
          'text-components-content-neutral-quaternary': form().disabled || !peutModifier(),
        }"
        hlmFieldLabel
        labelRequired
        >Type</label
      >
      @if (!type.value && !estCertifiante.value && !etape()?.estDupliquee && showErrors()) {
        <hlm-field-error>Le type est obligatoire si l'étape n'est pas certifiante.</hlm-field-error>
      }
      <hlm-radio-group class="gap-md flex" [disabled]="!peutModifier()" formControlName="type">
        <hlm-radio id="radio-prf" value="PRF"
          ><hlm-radio-indicator indicator />
          <label class="flex items-center" for="radio-prf"> Perfectionnement (PRF)</label>
        </hlm-radio>
        <hlm-radio id="radio-fsa" value="FSA"
          ><hlm-radio-indicator indicator />
          <label class="flex items-center" for="radio-fsa"> Formation supérieure (FSA) </label>
        </hlm-radio>
      </hlm-radio-group>
    </div>
  } @else {
    <app-detail-certification [form]="detailFormService.certifications" [referentiel]="referentiel()" />
  }
</form>
